import { CREATE_MESSAGE } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CREATE_MESSAGE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CREATE_MESSAGE.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case CREATE_MESSAGE.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
